import { DashcamDto, DeviceDto, DriverDto, VehicleFuelType } from '@fleet-beat/api';
import { BaseEntityDto, VehicleOwnershipEnum } from '@fleet-beat/core';

export interface VehicleDto extends BaseEntityDto {
  id?: string;
  companyId?: string;
  name?: string;
  vin?: string;
  model?: string;
  vendor?: string;
  property?: VehicleOwnershipEnum;
  status?: 'used';
  truckActivity?: string;
  description?: string;
  registrationNumber?: string;
  registrationNumberExpiry?: string;
  registrationNumberIssuingState?: string;
  specialVehicle?: boolean;
  insuranceCertificate?: string;
  insuranceCertificateExpiry?: string;
  dotInspectionNumber?: string;
  dotInspectionNumberExpiry?: string;
  rentId?: string;
  sleepingBerth?: boolean;
  rentalAgreement?: string;
  rentalAgreementExpiry?: string;
  height?: number;
  length?: number;
  width?: number;
  weight?: number;
  bodyAssemblyYear?: number;
  engineVolume?: number;
  color?: string;
  engineAssemblyYear?: number;
  axlesQuantity?: number;
  engineHorsepowerFrom?: number;
  engineHorsepowerTo?: number;
  fuelType?: VehicleFuelType;
  fuelTankVolume?: number;
  payload?: number;
  drivers?: DriverDto[];
  cameras?: DashcamDto[];
  params?: VehicleParamsDto[];
  tracking?: boolean;
  device?: DeviceDto;
  driverName?: string;
  driverId?: string;
  driver?: DriverDto;
  coDriver?: DriverDto;
  ovmsStatus?: 'active' | 'inactive' | null;
  vehicleId?: string;
  openVehiclesId?: string;
  enable?: boolean;
  type?: 'ovms';
  isActive?: boolean;

  speed?: number;
  hasParams?: boolean;
  hasDevice?: boolean;
  transmissionOnline?: boolean;
  lastSync?: string;
}

export interface VehicleParamsDto extends BaseEntityDto {
  truckId?: string;
  group?: VehicleParamsGroupEnum;
  name?: VehicleParamsNameEnum;
  value?: string;
  metaData?: VehicleParamsMetaDataDto;
}

export interface DeviceParamsDto extends VehicleParamsDto {
  deviceId?: string;
}

export interface VehicleParamsMetaDataDto {
  nearestPlace?: string;
  lat?: number;
  lon?: number;
}

export enum VehicleParamsGroupEnum {
  ECU = 'ecu',
  LOCATION = 'location',
  ENVIRONMENT = 'environment',
}

export enum VehicleParamsNameEnum {
  ENGINE_RPM = 'engine-rpm',
  ENGINE_HOURS = 'engine-hours',
  DIRECTION = 'direction',
  ODOMETER = 'odometer',
  LOCATION = 'location',
  SPEED = 'speed',
  GPS_SPEED = 'gps-speed',

  VOLTAGE_AUXILIARY = 'voltage-auxiliary',
  BATTERY_VOLTAGE = 'battery-voltage',
  ENGINE_TEMP = 'engine-temp',
  IS_DRIVABLE = 'is-drivable',
  ALT = 'alt',
  GPS_SIGNAL_QUALITY = 'gps-signal-quality',
  FUEL_CONSUMPTION = 'fuel-consumption',
  INTAKE_AIR_TEMP = 'intake-air-temp',
  INLET_AIR_TEMP = 'inlet-air-temp',
  SERIAL = 'serial',
  HARDWARE = 'hardware',
  FUEL_LEVEL = 'fuel-level',
  VIN = 'vin',
  MASS_AIR_FLOW_SENSOR = 'mass-air-flow-sensor',
  ENGINE_LOAD = 'engine-load',
  MANIFOLD_ABSOLUTE_PRESSURE = 'manifold-absolute-pressure',
  ENGINE_THROTTLE_POSE = 'engine-throttle-pose',
  ENGINE_OIL_TEMP = 'engine-oil-temp',
  ENGINE_OIL_PRESS = 'engine_oil_press',
  TYRE_FRONT_LEFT_TEMP = 'tyre-front-left-temp',
  TYRE_FRONT_RIGHT_TEMP = 'tyre-front-right-temp',
  TYRE_FRONT_LEFT_PRESSURE = 'tyre-front-left-pressure',
  TYRE_FRONT_RIGHT_PRESSURE = 'tyre-front-right-pressure',
  TYRE_REAR_LEFT_OUTSIDE_TEMP = 'tyre-rear-left-outside-temp',
  TYRE_REAR_RIGHT_OUTSIDE_TEMP = 'tyre-rear-right-outside-temp',
  TYRE_REAR_LEFT_OUTSIDE_PRESSURE = 'tyre-rear-left-outside-pressure',
  TYRE_REAR_RIGHT_OUTSIDE_PRESSURE = 'tyre-rear-right-outside-pressure',
  TYRE_REAR_LEFT_INSIDE_TEMP = 'tyre-rear-left-inside-temp',
  TYRE_REAR_RIGHT_INSIDE_TEMP = 'tyre-rear-right-inside-temp',
  TYRE_REAR_LEFT_INSIDE_PRESSURE = 'tyre-rear-left-inside-pressure',
  TYRE_REAR_RIGHT_INSIDE_PRESSURE = 'tyre-rear-right-inside-pressure',
}
